_ = require 'underscore'
Board = require 'app/scripts/models/board'
Controller = require 'app/scripts/controller'
React = require 'react'
Auth = require 'app/scripts/db/auth'
{ logError } = require 'app/scripts/debug/log-error'
l = require 'app/scripts/lib/localize'
t = require('app/scripts/views/internal/recup-with-helpers')('onboarding')
{ trackUe } = require '@trello/analytics'
{ verticals } = require 'app/scripts/views/onboarding/constants'
{ copyBoardFromVertical, getLocale, getBoardDataForVertical } = require 'app/scripts/views/onboarding/helpers'
{ IconName } = require 'app/common/components/controls/icon'
{ navigate } = require 'app/scripts/controller/navigate'

module.exports = class WelcomeComponent extends React.Component

  constructor: ->
    super

    formattedVerticals = Object.keys(verticals).map (vertical) => Object.assign(verticals[vertical], {
      key: vertical
    })
    [verticalsToSort, verticalsToShuffle] = _.partition(formattedVerticals, (d) -> !isNaN(d.sortId))
    @verticals = verticalsToSort
      .sort (a, b) => a.sortId - b.sortId
      .concat _.shuffle(verticalsToShuffle)

    @locale = getLocale()

    @state =
      selectedVertical: null
      saving: false

  handleChangeSelect: (e) ->
    trackUe('Welcome Screen', 'changes vertical', e.target.value, '', '', '', {
      lastVertical: @state.selectedVertical,
      nextVertical: e.target.value
    })
    if e.target.value == 'choose-something'
      this.setState({ selectedVertical: null })
    else
      this.setState({ selectedVertical: e.target.value }, =>
        @ctaButton.scrollIntoView({ behavior: 'smooth' })
      )

  handleGetStarted: (e) ->
    trackUe('Welcome Screen', 'clicks', 'get started', '', '', '', { vertical: @state.selectedVertical })
    v = if @state.selectedVertical == 'other' then  'default' else @state.selectedVertical
    navigate("/create-first-board?selectedVertical=#{v}", { trigger: true })

  handleDiveIn: ->
    vertical = @state.selectedVertical
    trackUe(
      'Welcome Screen',
      'clicks',
      'dive in',
      '',
      '',
      '',
      { vertical }
    )
    @setState { saving: true }

    copyBoardFromVertical(@modelCache, vertical)
      .catch ->
        logError new Error('Error copying board'),
          'welcome.coffee',
          '58',
          '58',
          {
            vertical,
            feature: 'Personalized Onboarding',
            source: 'Welcome Screen',
          }

        { name } = getBoardDataForVertical(vertical)
        Board.assistedCreate(name)
      .then (board) ->
        Controller.displayBoard
          idBoard: board.id
          openListComposer: false
      .catch ->
        Controller.displayErrorPage()
      .finally =>
        @setState { saving: false, }

  render: t.renderable ->
    { selectedVertical, saving } = @state
    { fullName } = Auth.me().attributes

    t.div '.welcome', =>
      t.div '.welcome--logo', =>
        t.img { src: require('resources/images/trello-logo-gray.svg') }
      t.div '.welcome--intro', =>
        t.h1 => t.format 'welcome'
        t.h1 => t.format 'what-brings-you-to-trello'
        t.p => t.format 'let-us-know-personalize'
      t.div '.welcome--card', =>
        t.div '.welcome--card-text-small', =>
          t.format 'hello-my-name-is'
        t.h1 => t.text fullName
        t.div '.welcome--card-text-small', =>
          t.format 'and-i-am-interested-in-trello-for'
        t.div '.welcome--select', =>
          t.icon IconName.Down
          t.select {
            class: t.classify({
              'welcome--select-placeholder': selectedVertical == null
            })
            onChange: (e) => @handleChangeSelect(e)
          }, =>
            t.option '.welcome--select-option.welcome--select-option--default', {
              value: 'choose-something'
            }, =>
              t.text t.l('choose-something')
            for { key } in @verticals
              t.option '.welcome--select-option', {
                value: key
              }, =>
                t.text t.l(key)
      if selectedVertical != null
        t.div '.welcome--cta-container', =>
        if verticals[selectedVertical].inspirationBoards[@locale] && selectedVertical != 'other'
          t.button '.welcome--cta-container--button.welcome--cta-container--button-blue', {
            onClick: (e) => @handleDiveIn(e),
            disabled: saving,
            class: t.classify({ 'disabled': saving })
          }, =>
            t.format 'dive-right-in'
          t.button '.welcome--cta-container--button', {
            onClick: (e) => @handleGetStarted(e),
            disabled: saving,
            class: t.classify({ 'disabled': saving })
            ref: (el) => (@ctaButton = el)
          }, =>
            t.format 'help-me-get-started'
        else
          t.button '.welcome--cta-container--button.welcome--cta-container--button-blue', {
            onClick: (e) => @handleGetStarted(e),
            disabled: saving,
            class: t.classify({ 'disabled': saving })
            ref: (el) => (@ctaButton = el)
          }, =>
            t.format 'get-started'
